var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransparentSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 18C36 27.9411 27.9411 36 18 36C8.05887 36 0 27.9411 0 18C0 8.05887 8.05887 0 18 0C27.9411 0 36 8.05887 36 18Z",
    fill: "#F1F4F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.244 28.1598L19.2449 28.1594C23.3381 26.4237 25.9996 22.3802 26 17.9011V12.7223C26 12.5064 25.8821 12.3065 25.6914 12.2039L18.0001 8L10.3024 12.2073C10.1151 12.3111 10 12.5087 10 12.7223V18.0061C10.0045 22.4315 12.6022 26.4365 16.6212 28.2104L17.7175 28.6856C17.7709 28.7002 17.8258 28.7069 17.8807 28.7059C17.937 28.7049 17.9932 28.6957 18.0474 28.6783L19.244 28.1598ZM17.8741 27.2276L18.6978 26.8707C18.6979 26.8707 18.6986 26.8704 18.6988 26.8704C22.2689 25.3563 24.5996 21.824 24.6 17.9011C24.6 17.901 24.6 17.9011 24.6 17.9011V13.2029L18 9.59548L11.4 13.2028V18.0053C11.4042 21.8806 13.678 25.3791 17.1824 26.9278L17.8741 27.2276Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9176 15.9344C22.1689 16.2282 22.1345 16.67 21.8407 16.9214L16.9378 21.1161C16.793 21.24 16.6039 21.2995 16.4143 21.2809C16.2246 21.2622 16.0508 21.1671 15.9329 21.0174L13.6448 18.1134C13.4056 17.8097 13.4578 17.3696 13.7614 17.1303C14.0651 16.8911 14.5052 16.9433 14.7445 17.2469L16.5815 19.5785L20.9306 15.8576C21.2244 15.6062 21.6662 15.6406 21.9176 15.9344Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparentSmall);
export default __webpack_public_path__ + "static/media/transparent-small.974b4efa.svg";
export { ForwardRef as ReactComponent };